export default __webpack_public_path__ + "static/media/blog1.dde6da64.jpg";